import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import {
  jsonToGenbank,
  jsonToFasta,
  cleanUpTeselagenJsonForExport
} from "@teselagen/bio-parsers";
import { HTMLSelect } from "@blueprintjs/core";
import { connectToEditor } from "../../withEditorProps";
import { compose } from "recompose";
class GenbankView extends React.Component {
  state = {
    fileTypeToView: "genbank"
  };
  select = () => this._input?.select();
  render() {
    const { sequenceData = {} } = this.props;
    let filestring;
    switch (this.state.fileTypeToView) {
      case "fasta":
        filestring = jsonToFasta(sequenceData);
        break;
      case "teselagen":
        filestring = JSON.stringify(
          cleanUpTeselagenJsonForExport(sequenceData),
          null,
          4
        );
        break;
      default:
        filestring = jsonToGenbank(sequenceData);
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        HTMLSelect,
        {
          className: "genbankFileView-type",
          fill: false,
          options: [
            { label: "Genbank", value: "genbank" },
            { label: "Fasta", value: "fasta" },
            { label: "Teselagen JSON", value: "teselagen" }
          ],
          onChange: (e) => {
            this.setState({ fileTypeToView: e.target.value });
          }
        }
      ),
      /* @__PURE__ */ jsx(
        "textarea",
        {
          "data-test": "ve-genbank-text",
          readOnly: true,
          onClick: this.select,
          style: {
            whiteSpace: "pre",
            overflowWrap: "normal",
            overflowX: "scroll",
            fontSize: 11,
            fontFamily: "monospace",
            height: 350
          },
          value: filestring
        }
      )
    ] });
  }
}
export default compose(
  connectToEditor(({ sequenceData = {} }) => {
    return {
      sequenceData
    };
  })
)(GenbankView);
